import React, { Component } from "react";
import preventClickthrough from 'react-prevent-clickthrough';
import { v4 as uuidv4 } from 'uuid';

import {
    CircularProgress,
    DialogTitle,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    Drawer,
    IconButton,
    AppBar,
    Toolbar,
    Typography,
    TextField,
    Tooltip,
    Switch,
    FormControl,
    InputLabel,
    FormControlLabel,
    Select,
    MenuItem,
    Checkbox
} from '@material-ui/core/';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import RefreshIcon from '@material-ui/icons/Refresh';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import NavigationClose from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Create';
import SaveIcon from '@material-ui/icons/Save';
import SaveAsIcon from '@material-ui/icons/FileCopy';
import CreateIcon from '@material-ui/icons/Create';
import CodeIcon from '@material-ui/icons/Code';
import WarningIcon from '@material-ui/icons/Warning';
import ExpandIcon from '@material-ui/icons/OpenWith';
import LayersClear from '@material-ui/icons/LayersClear';

import SortableTree, { walk, getNodeAtPath } from "react-sortable-tree";
import FileExplorerTheme from 'react-sortable-tree-theme-full-node-drag';

import {
    isArrayValid
} from '../utils/Utils';

import {
    validateRecommendModel,
} from '../utils/RecommendModelValidator'

import {
    Logger
} from '@apricityhealth/web-common-lib';

import RecommendationTypesView from './RecommendationTypesView';
import EditConditionGroupDialog from '../dialogs/EditConditionGroupDialog';
import EditRecommendationType from '../dialogs/EditRecommendationDialog';
import EditCategoryDialog from '../dialogs/EditCategoryDialog';
import JsonDialog from '../dialogs/JsonDialog';
import OverrideDialog from "../dialogs/OverrideDialog";
import SaveToPlanDialog from "../dialogs/SaveToPlanDialog";

import SelectRecommendation from "@apricityhealth/web-common-lib/components/SelectRecommendation";
import createIdFromText from "../utils/CreateIdFromText";
import getErrorMessage from "@apricityhealth/web-common-lib/utils/getErrorMessage";

import ChangedByButton from "../components/ChangedByButton";

import '../styles/workup.css';
import 'react-perfect-scrollbar/dist/css/styles.css';

const log = new Logger();

class EditRecommendationModelDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: JSON.parse(JSON.stringify(props.model)),     // make a copy 
            recommendationTypes: [],
        }
    }
    onDone() {
        let { model } = this.state;
        if (this.props.onDone)
            this.props.onDone(model);
    }
    onCancel() {
        if (this.props.onCancel)
            this.props.onCancel();
    }

    render() {
        const self = this;
        let { model } = this.state;

        return <Dialog open={true}>
            <DialogTitle>Edit Recommendation Model</DialogTitle>
            <DialogContent>
                <TextField disabled={true} style={styles.name} label="Model ID" value={model.modelId} onChange={(e) => {
                    model.modelId = e.target.value;
                    self.setState({ model });
                }} />
                <br />
                <TextField style={styles.name} label="Name" value={model.name} onChange={(e) => {
                    model.name = e.target.value;
                    model.modelId = createIdFromText(model.name);
                    self.setState({ model });
                }} />
                <br />
                <TextField style={styles.description} label="Description" value={model.description} onChange={(e) => {
                    model.description = e.target.value;
                    self.setState({ model });
                }} />
                <br />
                <FormControlLabel
                    style={{ margin: 5 }}
                    control={<Checkbox
                        checked={model.guideline}
                        name='dependencies'
                        onChange={(e, v) => {
                            model.guideline = v;
                            self.setState({ model });
                        }}
                    />}
                    label="Show in guidelines?"
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" style={styles.button} onClick={this.onDone.bind(this)}>Save</Button>
                <Button variant="contained" style={styles.button} onClick={this.onCancel.bind(this)}>Cancel</Button>
            </DialogActions>
        </Dialog>;
    }
}

class EditRecommendationDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialog: null,
            recommendation: JSON.parse(JSON.stringify(props.recommendation))     // make a copy 
        }
    }

    onDone() {
        let { recommendation } = this.state;
        if (this.props.onDone)
            this.props.onDone(recommendation);
    }
    onCancel() {
        if (this.props.onCancel)
            this.props.onCancel();
    }

    onEditRecommendationType(recommendation) {
        if (!recommendation) {
            recommendation = {
                name: "",
                description: "",
                category: "",
                option: '0',
                type: "",
                recommendId: uuidv4()
            }
        }
        this.setState({
            dialog: <EditRecommendationType
                recommendation={recommendation}
                appContext={this.props.appContext}
                onCancel={() => {
                    this.setState({ dialog: null });
                }}
                onDone={(type) => {
                    const { appContext: { stores: { DataTypesStore }}} = this.props;

                    DataTypesStore.saveRecommendType(type).then((type) => {
                        const { recommendation } = this.state;
                        recommendation.recommendId = type ? type.recommendId : '';
                        recommendation.name = type ? type.name : '';
                        this.setState({ dialog: null, recommendation });
                    }).catch((err) => {
                        console.error("saveRecommendation error:", err);
                    })
                }} />
        });
    }

    render() {
        const self = this;
        const { appContext: { stores: { DataTypesStore } } } = this.props;
        let { recommendation, dialog } = this.state;
        if (!recommendation.protocol) recommendation.protocol = ["none"];
        if (!Array.isArray(recommendation.protocol)) {
            let protocol = recommendation.protocol;
            recommendation.protocol = [protocol];
        }

        return <Dialog open={true} maxWidth={'md'} PaperProps={{ style: { overflowY: 'visible' } }}>
            <DialogTitle>Edit Recommendation</DialogTitle>
            <DialogContent style={{ overflowY: 'visible' }}>
                <SelectRecommendation appContext={this.props.appContext} 
                    style={{ margin: 5, width: 550 }}
                    recommendId={recommendation.recommendId}
                    onChange={(recommend) => {
                        recommendation.recommendId = recommend ? recommend.recommendId : '';
                        recommendation.name = recommend ? recommend.name : '';
                        self.setState({ recommendation });
                    }}
                    onEdit={this.onEditRecommendationType.bind(this)}
                    onCreate={this.onEditRecommendationType.bind(this)}
                />
                <br />
                <TextField style={{ margin: 5, width: 550}} multiline label="Name" value={recommendation.name} onChange={(e) => {
                    recommendation.name = e.target.value;
                    self.setState({ recommendation });
                }} />
                <br />
                <TextField style={{ margin: 5, width: 550}} multiline label="Explanation" value={recommendation.explanation} onChange={(e) => {
                    recommendation.explanation = e.target.value;
                    self.setState({ recommendation });
                }} />
                <br />
                <FormControl style={{ margin: 5, width: 550 }}>
                    <InputLabel>Protocol/Highlight Recommendation</InputLabel>
                    <Select
                        value={recommendation.protocol}
                        multiple
                        onChange={(e) => {
                            log.debug(`recommend protocol value `, e.target.value)
                            recommendation.protocol = e.target.value;
                            self.setState({ recommendation });
                        }
                        }>
                        {DataTypesStore.getRecommendProtocols().map((item) => (
                            <MenuItem key={item.protocolId} value={item.protocolId}>
                                {item.name}
                            </MenuItem>
                        ))}

                    </Select>

                </FormControl>
                <br />
                <TextField style={styles.weight} type="number" label="Weight" value={recommendation.weight} onChange={(e) => {
                    recommendation.weight = e.target.value;
                    self.setState({ recommendation });
                }} />
                <br />
                {dialog}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" style={styles.button} onClick={this.onDone.bind(this)}>Save</Button>
                <Button variant="contained" style={styles.button} onClick={this.onCancel.bind(this)}>Cancel</Button>
            </DialogActions>
        </Dialog>;
    }
}

class RecommendModelView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modelId: props.modelId || '',
            name: props.name || '',
            dialog: null,
            drawerOpen: false,
            modified: false,
            copyEnabled: false,
            wideDrawer: false,
            badRecommendations: [],
            badCategories: [],
            model: null,
            recommendations: null
        };

        this.expanded = {};
    }

    componentDidMount() {
        this.loadModel(this.props.modelId);
    }

    componentWillUnmount() {
    }

    componentDidUpdate(oldProps) {
        if (oldProps.modelId !== this.props.modelId) {
            this.loadModel(this.props.modelId);
        }
    }

    onCloseView() {
        if (this.state.modified === true) {
            this.displayModifiedDialog(this.props.onClose);
        }
        else
            this.props.onClose();
    }

    displayModifiedDialog(done) {
        const self = this;
        let dialog = <Dialog open={true}>
            <DialogTitle>Recommend Model Modified!</DialogTitle>
            <DialogContent>This recommend model has been modified, would you like to save any changes?</DialogContent>
            <DialogActions>
                <Button variant="contained" style={styles.button} onClick={(e) => {
                    self.setState({ modified: false, dialog: null });
                    self.saveModel(done);
                }}>Yes</Button>
                <Button variant="contained" style={styles.button} onClick={(e) => {
                    self.setState({ modified: false, dialog: null }, done);
                }}>No</Button>
            </DialogActions>
        </Dialog>;

        this.setState({ dialog });
    }

    displayOverrideDialog(oldPlanId, callback) {
        this.setState({
            dialog: <OverrideDialog appContext={this.props.appContext}
                oldPlanId={oldPlanId} parent={this} onConfirm={callback} />
        });
    }

    onToggleDrawer() {
        this.setState({ drawerOpen: !this.state.drawerOpen });
    }

    loadModel(modelId) {
        const { appContext: { stores: { DataTypesStore } } } = this.props;

        log.debug("LoadModel:", modelId);
        if (this.state.modified === true) {
            return this.displayModifiedDialog(this.loadModel.bind(this, modelId));
        }

        this.setState({ progress: <CircularProgress size={20} />, error: null });

        let loadModels = modelId ? Promise.resolve(DataTypesStore.getRecommendModels().filter((m) => m.modelId === modelId)) : Promise.resolve();
        loadModels.then((recommendModels) => {
            let model = null;
            let modified = false;
            if (!isArrayValid(recommendModels)) {
                model = this.createNewModel();
                modified = true;
            } else {
                model = recommendModels[0]
            }
            this.setState({
                modelId,
                model,
                modified,
                dialog: null,
                progress: null
            }, this.loadRecommendations.bind(this));
        }).catch((err) => {
            this.setState({ dialog: null, progress: null, error: getErrorMessage(err) });
        });
    }

    loadRecommendations() {
        const { appContext: { stores: { DataTypesStore } } } = this.props;
        this.setState({ recommendations: DataTypesStore.getRecommendationTypes() }, this.validateModel.bind(this))
    }

    validateModel() {
        const { model } = this.state;
        this.setState({ ...validateRecommendModel(this.props.appContext, model) }, this.initalizeTreeData.bind(this));
    }

    createNewModel() {
        let recommendModel = this.props.model || {
            modelId: '',
            name: ``,
            description: ``,
            groups: [this.createNewGroup()]
        };
        return recommendModel;
    }

    createNewGroup(type) {
        let recommendGroup = {
            type: type || 'Triage Advisory',
            name: "A New Group",
            description: "A New Group",
            addAlert: [],
            deleteAlert: [],
            categories: [],
            treeId: uuidv4()
        };
        return recommendGroup
    }

    saveCategoryTypes() {

    }

    saveNewRecommendationTypes() {
        const { appContext: { stores: { DataTypesStore }}} = this.props;
        const { model } = this.state;

        this.setState({ dialog: null, progress: <CircularProgress size={20} />, error: null });
        return Promise.all(model.groups.map(async (group) => {
            return await Promise.all(group.categories.map( async (category) => {
                return await Promise.all(category.recommendations.map(async (recommend) => {
                   if (! recommend.recommendId ) {
                        const newType = await DataTypesStore.saveRecommendType(recommend);
                        recommend.recommendId = newType.recommendId;
                   }    
                }))
            }))
        })).then(() => {
            this.setState({ progress: null, ...validateRecommendModel(this.props.appContext, model )} );
        }).catch((err) => {
            log.error("saveNewRecommendationTypes error:", err );
            this.setState({ progress: null, error: getErrorMessage(err)});
        });
    }

    saveModel(callback, planId = null) {
        const { appContext, appContext: { stores: { DataTypesStore } } } = this.props;
        const { model } = this.state;

        if (!planId && model.planId && model.planId !== appContext.state.plan.planId) {
            return this.displayOverrideDialog(model.planId, this.saveModel.bind(this, callback));
        }

        this.setState({ dialog: null, progress: <CircularProgress size={20} />, error: null });
        DataTypesStore.saveRecommendModel(model, planId).then((response) => {
            log.debug("saveModel response:", response);
            this.setState({
                ...validateRecommendModel(appContext, response),
                model: response,
                modified: false,
                progress: null
            }, callback);
        }).catch((error) => {
            console.error("save model error:", error);
            this.setState({ progress: null, error: getErrorMessage(error) });
        });
    }

    saveToPlan(callback) {
        const { appContext: { stores: { DataTypesStore } } } = this.props;
        const { model } = this.state;

        let dialog = <SaveToPlanDialog appContext={this.props.appContext} planId={model.planId} onCancel={this.onCloseDialog.bind(this)}
            onDone={({ plan, move }) => {
                log.debug("plan:", plan, ", move: ", move);
                let originalModel = { ...model };
                this.saveModel(() => {
                    if (move) {
                        DataTypesStore.deleteRecommendModel(originalModel.modelId, originalModel.planId).then(() => {
                            this.onCloseView();
                        }).catch((err) => {
                            this.setState({ error: getErrorMessage(err) }, callback);
                        });
                    } else {
                        callback();
                    }
                }, plan.planId);
            }} />;
        this.setState({ dialog });
    }

    onCloseDialog() {
        this.setState({ dialog: null });
    }

    deleteModel() {
        const { model } = this.state;
        const { appContext: { stores: { DataTypesStore } } } = this.props;

        log.debug("deleteModel:", model);

        let dialog = <Dialog open={true}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>Delete this recommendation model, are you sure?</DialogContent>
            <DialogActions>
                <Button variant="contained" style={styles.button} onClick={(e) => {
                    this.setState({ progress: <CircularProgress size={20} />, error: null });
                    DataTypesStore.deleteRecommendModel(model.modelId, model.planId).then(() => {
                        this.setState({ progress: null, dialog: null }, this.onCloseView.bind(this));
                    }).catch((err) => {
                        console.error("deleteRecommendationModel failed:", err);
                        this.setState({ progress: null, dialog: null, error: getErrorMessage(err) });
                    })
                }}>Yes</Button>
                <Button variant="contained" style={styles.button} onClick={(e) => {
                    this.setState({ progress: null, dialog: null });
                }}>No</Button>
            </DialogActions>
        </Dialog>;

        this.setState({ dialog });
    }

    onAddGroup() {
        let { model } = this.state;
        let newGroup = this.createNewGroup();
        model.groups.splice(0, 0, newGroup);
        this.setState({ model, modified: true }, this.validateModel.bind(this));
    }

    onDeleteGroup(group) {
        const self = this;
        let { model } = this.state;
        let groupIndex = model.groups.indexOf(group);
        if (groupIndex >= 0) {
            model.groups.splice(groupIndex, 1);
            self.setState({ model, dialog: null, modified: true }, self.validateModel.bind(self))
        }
    }

    onEditGroup(model, group, e) {
        preventClickthrough(e);

        let { appContext } = this.props;

        const self = this;
        this.setState({
            dialog: <EditConditionGroupDialog
                model={model}
                group={group}
                appContext={appContext}
                onCancel={() => {
                    this.setState({ dialog: null });
                }}
                onDone={(update) => {
                    for (let k in update) {
                        group[k] = update[k];
                    }
                    self.setState({ modified: true, dialog: null }, self.validateModel.bind(self));
                }} />
        });
    }

    onAddCategory(group) {
        group.categories.splice(0, 0, {
            name: "New Category",
            recommendations: [],
            treeId: uuidv4(),
        });
        this.validateModel();
    }

    onAddRecommentation(category) {
        category.recommendations.splice(0, 0, {
            name: '',
            recommendId: '',
            explanation: '',
            weight: 1,
            treeId: uuidv4()
        });
        this.validateModel();
    }

    onEditCategory(category) {
        let self = this;
        this.setState({
            dialog: <EditCategoryDialog
                style={{ width: '100%' }}
                category={category}
                appContext={this.props.appContext}
                onCancel={() => {
                    self.setState({ dialog: null });
                }}
                onDone={(update) => {
                    for (let k in update)
                        category[k] = update[k];
                    self.setState({ dialog: null }, self.validateModel.bind(self));
                }} />
        });
    }

    onShowCode() {
        let { model } = this.state;
        let { appContext } = this.props;
        this.setState({
            dialog: <JsonDialog
                appContext={appContext}
                dataType={model}
                onEditDone={(model) => {
                    this.setState({ model, dialog: null });
                }}
                onDone={() => {
                    this.setState({ dialog: null });
                }} />
        });
    }

    onEditRecommendationModel() {
        let { model } = this.state;
        const self = this;
        let dialog = <EditRecommendationModelDialog model={model} onDone={(model) => {
            log.debug("onEditRecommendationModel done:", model);
            self.setState({ dialog: null, model, modified: true });
        }} onCancel={() => {
            self.setState({ dialog: null });
        }} />;
        this.setState({ dialog });
    }

    getCategoryChildren(group, category) {
        const { recommendations } = this.state;

        let nodes = [];
        if (isArrayValid(category.recommendations)) {
            let recs = category.recommendations;
            for (let i = 0; i < recs.length; ++i) {
                let recommendation = recs[i];
                if (!recommendation.treeId)
                    recommendation.treeId = recommendation._id || uuidv4();

                let type = recommendations.find((e) => e.recommendId === recommendation.recommendId);
                // update the data in the model with the latest name from the type
                if (type) recommendation.name = type.name;

                let node = {
                    nodeType: 'recommendation',
                    recommendation,
                    category,
                    group,
                    text: type && type.name ? type.name.substring(0, 80) : recommendation.name,
                    subtitle: type ? undefined : 'New Recommendation Type',
                    error: type && type.name ? false : true,
                    children: []
                };
                nodes.push(node)
            }
        }

        return nodes;
    }

    getGroupChildren(group) {
        const { appContext: { stores: { DataTypesStore } } } = this.props;

        let nodes = [];
        if (isArrayValid(group.categories)) {
            for (let i = 0; i < group.categories.length; ++i) {
                let category = group.categories[i];
                if (!category.treeId)
                    category.treeId = category._id || uuidv4();

                let cat = DataTypesStore.getRecommendCategories().find((e) => e.categoryId === category.name);
                let node = {
                    nodeType: 'category',
                    category,
                    group,
                    text: cat ? cat.name : category.name,
                    error: cat ? false : true,
                    treeId: category.treeId,
                    children: this.getCategoryChildren(group, category),
                    expanded: this.expanded[category.treeId]
                }

                nodes.push(node);
            }
        }
        return nodes;
    }

    onExpandNodes() {
        let expanded = false;
        this.onChangeTree(this.state.treeData);     // capture the current expanded state
        for (let k in this.expanded) expanded |= this.expanded[k];
        for (let k in this.expanded) this.expanded[k] = !expanded;
        log.debug(`onExpandNodes, new state: ${expanded}:`, this.expanded);
        this.initalizeTreeData();                   // apply the new expanded state
    }

    initalizeTreeData() {
        const self = this;
        const { appContext: { stores: { DataTypesStore } } } = this.props;
        const { model } = this.state;

        let treeData = [];
        if (model && isArrayValid(model.groups)) {
            for (let i = 0; i < model.groups.length; i++) {
                let group = model.groups[i];
                if (!group.treeId)
                    group.treeId = group._id || uuidv4();

                let type = DataTypesStore.getRecommendGroupTypes().find((e) => e.typeId === group.type);
                let node = {
                    nodeType: 'group',
                    group,
                    error: type ? false : true,
                    text: `${group.name} (${type ? type.name : group.type})`,
                    treeId: group.treeId,
                    expanded: this.expanded[group.treeId]
                };

                node.children = this.getGroupChildren(group);
                treeData.push(node);
            }
        }
        self.setState({ treeData });
    }

    canDrop(args) {
        const { node, nextParent } = args;
        //log.debug("canDrop:", node, nextParent);
        if (node.nodeType === 'group') {
            // groups can only be on the root
            return !nextParent;
        }
        else if (node.nodeType === 'category') {
            // categories can only be attached to a group
            return nextParent && nextParent.nodeType === 'group';
        }
        else if (node.nodeType === 'recommendation') {
            // recommendations can only be attached to a category
            return nextParent && nextParent.nodeType === 'category';
        }
        return false;
    }

    findNode(treeData, treeId) {
        let node = null;
        walk({
            treeData,
            callback: (rowInfo) => {
                //log.debug("rowInfo:", rowInfo );
                if (rowInfo.node.treeId === treeId) {
                    node = rowInfo.node;
                }
            },
            getNodeKey: ({ treeIndex }) => treeIndex,
            ignoreCollapsed: true,
        });
        log.debug(`findNode, treeId: ${treeId}:`, node, treeData);
        return node;
    }

    onMoveNode(args) {
        log.debug("onMoveNode:", args);
        let { node, prevPath, treeData } = args;
        if (this.state.copyEnabled) {
            let { prevTreeData } = this.state;

            // copy is enabled, so when a node is moved, make a copy of the moved node, and put
            // a copy back in it's original location. 

            let copy = null;
            if (node.nodeType === 'category') {
                copy = JSON.parse(JSON.stringify(node));
                copy.treeId = copy.category.treeId = uuidv4();
                delete copy.category._id;
            } else if (node.nodeType === 'recommendation') {
                copy = JSON.parse(JSON.stringify(node));
                copy.treeId = copy.recommendation.treeId = uuidv4();
                delete copy.recommendation._id;
            } else if (node.nodeType === 'group') {
                copy = JSON.parse(JSON.stringify(node));
                copy.treeId = copy.group.treeId = uuidv4();
                delete copy.group._id;
            }

            if (copy) {
                prevPath.pop();
                let prevParent = getNodeAtPath({
                    treeData: prevTreeData,
                    path: prevPath,
                    getNodeKey: ({ treeIndex }) => treeIndex,
                    ignoreCollapsed: true
                });
                //log.debug("prevParent:", prevParent );
                let nodeIndex = prevParent ? prevParent.node.children.findIndex((e) => e.treeId === node.treeId) :
                    prevTreeData.findIndex((e) => e.treeId === node.treeId);
                if (nodeIndex >= 0) {
                    let newParent = this.findNode(treeData, prevParent.node.treeId);
                    //log.debug(`Copy node, nodeIndex: ${nodeIndex}, newParent:`, newParent, "prevParent:", prevParent.node, "copy:", copy );
                    if (newParent)
                        newParent.children.splice(nodeIndex, 0, copy);
                    else
                        treeData.splice(nodeIndex, 0, copy);
                    this.onChangeTree(treeData);
                }
            }
        }
    }

    onChangeCategoryNode(node) {
        let category = node.category;
        category.recommendations = [];
        for (let i = 0; i < node.children.length; ++i) {
            let child = node.children[i];
            if (child.nodeType !== 'recommendation') continue;
            child.category = category;
            this.expanded[child.treeId] = child.expanded;
            category.recommendations.push(child.recommendation);
        }
    }

    onChangeGroupNode(node) {
        let group = node.group;
        group.categories = [];
        for (let i = 0; i < node.children.length; ++i) {
            let child = node.children[i];
            if (child.nodeType !== 'category') continue;
            child.group = group;
            this.expanded[child.treeId] = child.expanded;
            this.onChangeCategoryNode(child);
            group.categories.push(child.category);
        }
    }

    onChangeTree(treeData) {
        log.debug("onChangeTree:", treeData);
        let { model } = this.state;
        model.groups = [];

        // save a copy of the previous tree data, so if we need to copy a node we can find the 
        // right location to insert
        let prevTreeData = this.state.treeData.slice();

        this.expanded = {};     // reset our expanded state
        for (let i = 0; i < treeData.length; ++i) {
            let node = treeData[i];
            if (node.nodeType !== 'group') continue;
            this.expanded[node.treeId] = node.expanded;
            this.onChangeGroupNode(node);
            model.groups.push(node.group);
        }

        this.setState({ treeData, prevTreeData });
    }

    onDeleteCategory(group, category) {
        log.debug("onDeleteCategory:", group, category);
        let index = group.categories.indexOf(category);
        if (index >= 0) {
            group.categories.splice(index, 1);
            this.setState({ modified: true }, this.validateModel.bind(this));
        }
    }

    onDeleteRecommendation(category, recommendation) {
        log.debug("onDeleteRecommendation:", category, recommendation);
        let index = category.recommendations.indexOf(recommendation);
        if (index >= 0) {
            category.recommendations.splice(index, 1);
            this.setState({ modified: true }, this.validateModel.bind(this));
        }
    }

    onEditRecommendation(category, recommendation) {
        log.debug("onEditRecommendation:", category, recommendation);
        const self = this;
        let dialog = <EditRecommendationDialog appContext={this.props.appContext} recommendation={recommendation} onDone={(result) => {
            log.debug("EditRecommendationDialog done:", result);
            for (let k in result) {
                recommendation[k] = result[k];
            }
            self.setState({ dialog: null, modified: true }, self.loadRecommendations.bind(self));
        }} onCancel={() => {
            self.setState({ dialog: null });
        }} />;

        this.setState({ dialog });
    }

    getNodeProps(args) {
        // log.debug("getNodeProps:", args );
        let { node } = args;

        let title = node.text;
        let subtitle = null;
        let buttons = [];

        if (node.nodeType === 'group') {
            buttons.push(<IconButton onClick={this.onEditGroup.bind(this, this.state.model, node.group)}><CreateIcon /></IconButton>);
            buttons.push(<IconButton onClick={this.onAddCategory.bind(this, node.group)}><AddIcon /></IconButton>);
            buttons.push(<IconButton key='delete' onClick={this.onDeleteGroup.bind(this, node.group)}><DeleteIcon /></IconButton>);
        }
        else if (node.nodeType === 'category') {
            buttons.push(<IconButton key='edit' onClick={this.onEditCategory.bind(this, node.category)}><EditIcon /></IconButton>);
            buttons.push(<IconButton onClick={this.onAddRecommentation.bind(this, node.category)}><AddIcon /></IconButton>);
            buttons.push(<IconButton key='delete' onClick={this.onDeleteCategory.bind(this, node.group, node.category)}><DeleteIcon /></IconButton>);
        }
        else if (node.nodeType === 'recommendation') {
            buttons.push(<div key='edit' style={{ fontSize: '12px' }}>{node.recommendation.weight}<IconButton onClick={this.onEditRecommendation.bind(this, node.category, node.recommendation)}><CreateIcon /></IconButton></div>);
            buttons.push(<IconButton key='delete' onClick={this.onDeleteRecommendation.bind(this, node.category, node.recommendation)}><DeleteIcon /></IconButton>);
            if (node.recommendation && node.recommendation.explanation)
                subtitle = node.recommendation.explanation
        }

        let style = node.error ? { height: 40, width: 500, maxWidth: 500, border: 0, boxShadow: `0 0 0 2px tomato`, cursor: 'pointer' }
            : { height: 40, width: 500, maxWidth: 500, border: 0, cursor: 'pointer' };

        return {
            listIndex: 0,
            lowerSiblingCounts: [],
            style,
            title: (<div style={{ fontSize: 16, maxWidth: "500px", border: 0, overflow: 'hidden', fontWeight: 'normal' }}
            >{title} </div>),
            subtitle,
            buttons
        };
    }

    showBadCategories() {
        const self = this
        const { badCategories } = this.state

        let badCatItems = []
        badCategories.forEach((item) => {
            const badItem = <TableRow key={badCatItems.length}>
                <TableCell>
                    {item.group}
                </TableCell>
                <TableCell>
                    {item.type}
                </TableCell>
                <TableCell>
                    {item.category}
                </TableCell>
            </TableRow>
            badCatItems.push(badItem)
        })
        var dialog =
            <Dialog
                maxWidth='lg'
                model="false"
                open={true}>
                <DialogTitle>Missing Categories</DialogTitle>
                <DialogContent>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Group</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Category</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {badCatItems}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" style={styles.button} onClick={(e) => {
                        self.setState({ dialog: null })
                    }}>Okay</Button>
                </DialogActions>
            </Dialog>
        this.setState({ dialog: dialog });
    }

    showBadRecommendations() {
        const { badRecommendations } = this.state

        let badRecItems = []
        badRecommendations.forEach((item) => {
            const badItem =
                <TableRow>
                    <TableCell>
                        {item.name}
                    </TableCell>
                    <TableCell>
                        {item.explanation}
                    </TableCell>
                </TableRow >
            badRecItems.push(badItem)
        })

        let dialog = <Dialog
            maxWidth='lg'
            model="false"
            open={true}>
            <DialogTitle>New Recommendation Types</DialogTitle>
            <DialogContent>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Recommendation</TableCell>
                            <TableCell>Explanation</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {badRecItems}
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" style={styles.button} onClick={() => this.setState({ dialog: null }, this.saveNewRecommendationTypes.bind(this))}>Save {badRecommendations.length} New Types</Button>
                <Button variant="contained" style={styles.button} onClick={() => this.setState({dialog: null})}>Cancel</Button>
            </DialogActions>
        </Dialog>
        this.setState({ dialog: dialog });
    }

    clearRecentlyChanged() {
        let { model } = this.state;
        let groups = model.groups || [];
        groups.forEach(group => {
            let categories = group.categories || [];
            categories.forEach(category => {
                let recommendations = category.recommendations || [];
                recommendations.forEach(recommendation => {
                    recommendation.protocol = 'none';
                });
            });
        });
        this.setState({ model });
    }

    render() {
        const self = this;
        const { treeData, dialog, model, drawerOpen, progress, error, copyEnabled, wideDrawer, badRecommendations, badCategories } = this.state;
        const { appContext } = this.props;

        let drawer = <Drawer variant="permanent" anchor="right" open={drawerOpen} onClose={() => { self.setState({ drawerOpen: !drawerOpen }) }}>
            <div style={{ display: drawerOpen ? 'block' : 'none' }} align="left"><IconButton onClick={() => { self.setState({ drawerOpen: !drawerOpen }) }}><ChevronRightIcon /></IconButton></div>
            <div style={{ display: drawerOpen ? 'none' : 'block' }} align="left"><IconButton onClick={() => { self.setState({ drawerOpen: !drawerOpen }) }}><ChevronLeftIcon /></IconButton></div>
            <div style={{ maxWidth: wideDrawer ? '60vw' : '40vw', display: drawerOpen ? 'block' : 'none' }}>
                <RecommendationTypesView appContext={appContext} editMode={true} externalNodeType={'recommendations'} onChange={self.loadRecommendations.bind(self)} />
            </div>
        </Drawer>;

        let title = model ? model.name : "";
        let sortableTree = treeData ?
            <div style={styles.treeWrap} valign='top'>
                <SortableTree
                    treeData={treeData}
                    isVirtualized={true}
                    maxDepth={3}
                    theme={FileExplorerTheme}
                    dndType={'recommendation'}
                    canDrop={this.canDrop.bind(this)}
                    onChange={this.onChangeTree.bind(this)}
                    onMoveNode={this.onMoveNode.bind(this)}
                    generateNodeProps={this.getNodeProps.bind(this)} />
            </div> : null;

        let showRecWarning = () => {
            if (badRecommendations.length > 0)
                return (
                    <Button
                        style={styles.recWarning}
                        variant="contained"
                        color="primary"
                        onClick={this.showBadRecommendations.bind(this)}
                    ><WarningIcon style={styles.warningIcon} />{badRecommendations.length} New Recommendation Types</Button>
                )
        }
        let showCatWarning = () => {
            if (badCategories.length > 0)
                return (
                    <Button
                        style={styles.recWarning}
                        variant="contained"
                        color="secondary"
                        onClick={this.showBadCategories.bind(this)}
                    ><WarningIcon style={styles.warningIcon} />{badCategories.length} Missing Categories</Button>
                )

        }
        let disableDelete = model ? model.planId !== appContext.state.plan.planId : true;
        let deleteModel = this.props.onClose ? <Tooltip title='Delete model'><span><IconButton disabled={disableDelete} onClick={this.deleteModel.bind(this)}><DeleteIcon /></IconButton></span></Tooltip> : null;
        let editModel = <table width="100%"><tbody>
            <tr >
                <td>
                    <IconButton onClick={this.onEditRecommendationModel.bind(this)}><EditIcon /></IconButton>{title}
                </td>
                <td>
                </td>
                <td align="right">
                    {showRecWarning()}
                    {showCatWarning()}
                    {error}
                    <Tooltip title='Save model'><span><IconButton disabled={progress !== null} onClick={this.saveModel.bind(this, this.validateModel.bind(this), null)}><SaveIcon /></IconButton></span></Tooltip>
                    <Tooltip title='Save To Plan'><IconButton disabled={progress !== null} onClick={this.saveToPlan.bind(this, this.validateModel.bind(this))}><SaveAsIcon /></IconButton></Tooltip>
                    <Tooltip title='Reload model'><span><IconButton disabled={progress !== null} onClick={this.loadModel.bind(this, this.state.modelId)}>{progress || <RefreshIcon />}</IconButton></span></Tooltip>
                    <Tooltip title='View model JSON'><span><IconButton onClick={this.onShowCode.bind(this)}><CodeIcon /></IconButton></span></Tooltip>
                    {deleteModel}
                </td>
                <td width="50"></td>
            </tr>
            <tr >
                <td>
                    <Tooltip title='Add new group'><span><IconButton onClick={this.onAddGroup.bind(this)}><AddIcon /></IconButton></span></Tooltip>
                    <Tooltip title='Expand/Collapse'><span><IconButton onClick={this.onExpandNodes.bind(this)}><ExpandIcon /></IconButton></span></Tooltip>
                </td>
                <td>
                </td>
                <td align="right">
                    <Tooltip title='Moving nodes will copy instead of move'>
                        <FormControlLabel control={<Switch checked={copyEnabled} onChange={(e) => self.setState({ copyEnabled: e.target.checked })} />}
                            label={'Copy Mode'} />
                    </Tooltip>
                    <Tooltip title='Clear Protocol'><span><IconButton onClick={() => this.clearRecentlyChanged()}>< LayersClear /></IconButton></span></Tooltip>
                </td>
            </tr>
            <tr>
                <td colSpan="2">
                    {sortableTree}
                    <div style={styles.footer}>
                        {model ? <ChangedByButton appContext={appContext} primaryKey={model.modelId} collection='RecommendModelModel' /> : null}
                    </div>
                    {drawer}
                    {dialog}
                </td>
            </tr>
        </tbody></table>;

        if (this.props.onClose) {
            return (
                <div align="center" style={{ width: '60vw' }} >
                    <AppBar style={styles.appBar} position="static">
                        <Toolbar>
                            <IconButton onClick={this.onCloseView.bind(this)}>
                                <NavigationClose />
                            </IconButton>
                            <Typography variant="h6" color="inherit">Recommendation Model</Typography>
                        </Toolbar>
                    </AppBar>
                    <div align="left" style={styles.div}>
                        {editModel}
                    </div>
                </div>
            );
        }
        else {
            return editModel;
        }
    }
}

const styles = {
    warningIcon: {
        marginRight: 10
    },
    recWarning: {
        marginLeft: 15,
        marginRight: 5,
        marginTop: 13
    },
    copy: {
        color: 'white',
        backgroundColor: 'tomato',
        marginLeft: 15,
        marginRight: 5,
        marginTop: 13
    },
    treeWrap: {
        height: 'calc(100vh - 265px)',
        width: '100%',
        position: 'absolute'
    },
    div: {
        margin: 10
    },
    description: {
        margin: 5,
        width: 500
    },
    footer: {
        bottom: 0,
        position: 'absolute',
        width: '100%',
        display: 'flex',
        alignItems: 'center'
    },
    name: {
        margin: 5,
        width: 300
    },
    weight: {
        margin: 5,
        width: 50
    },
    dialogItem: {
        width: '20%',
        display: 'inline-block',
        textAlign: 'left'
    },
};

export default RecommendModelView;
